var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#073C50",
    fillRule: "evenodd",
    d: "M6,28 L6,42 L42,42 L42,28 L48,28 L48,48 L0,48 L0,28 L6,28 Z M24.1213203,4.4408921e-14 L42.2426407,18.1213203 L38,22.363961 L27.385,11.749 L27.3452949,33.2482164 L21.3453053,33.2370649 L21.386,11.22 L10.2426407,22.363961 L6,18.1213203 L24.1213203,4.4408921e-14 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.6755a5cabdb9c5046c3c6b730da28fb7.svg";
export { ForwardRef as ReactComponent };